import {setInitialState} from '../../../utils/reducerOperations';
export const Default=()=>({
    fetchSpreadAnalysisApi:setInitialState(),
});